
export default function (req) {
    const isLocal = process.env.NODE_ENV === 'local';

    const mysql = {
        client: 'mysql2',
        connection: isLocal ? {
            host: process.env.DB_HOST,
            user: process.env.DB_USER,
            password: process.env.DB_PASSWORD,
            database: process.env.DB_DATABASE
        } : {
            host: keys.DB_HOST,
            user: keys.DB_USER,
            password: keys.DB_PASSWORD,
            database: keys.DB_DATABASE
        }
    }


    return {mysql}
}
